<template>
  <div>
    <section class="content checkout-content d-flex
     justify-content-center align-items-center">
      <div class="container">
        <div class="row">
          <div class="col-12 margin-adjustment col-lg-6 ml-2 p-3
            my-4 card">
            <form
              data-vv-scope="register"
              @submit.prevent="action('register')"
            >
              <center>
                <h1
                  class="h3 mb-3 font-weight-normal"
                  id="reset-passwrd-head"
																		data-test="resetPasswordHeading"
                >
                  <b id="reset-passwrd-head-bold"
																					data-test="resetPasswordBold">
                    Reset Password
                  </b>
                </h1>
              </center>
              <div class="number-prefix">
                <!-- Password Input field and error-->
                <input
                  v-validate="'required|min:6'"
                  :class="(showSignUpError &&
                         errors.has('register.password'))?'is-invalid':''"
                  class="col-12 form-control login-signup-input mt-2"
                  data-ismobileonly="false"
                  name="password"
                  type="password"
                  placeholder="Password"
                  id="reset-passwrd"
                  v-model="password"
                  autocomplete="off"
                  ref="password"
																		data-test="resetPasswordPasswordInput"
                >
                <div
                  class="invalid-feedback"
                  v-if="showSignUpError"
                  v-show="errors.has('register.password')"
																		data-test="resetPasswordPasswordInputError"
																		id="resetPasswordPasswordInputError"
                >
                  {{errors.first('register.password')}}
                </div>
                <!--Confirm Password Input field and error-->
                <input
                  v-validate="'required|confirmed:password'"
                  :class="(showSignUpError &&
                         errors.has('register.confirmpassword'))?
                         'is-invalid':''"
                  class="col-12 form-control login-signup-input mt-2"
                  name="confirmpassword"
                  type="password"
                  placeholder="Confirm Password"
                  id="reset-confirm-passwrd"
                  autocomplete="off"
                  v-model="confirmPassword"
                  data-ismobileonly="false"
																		data-test="resetPasswordConfirmPasswordInput"
                >
                <div
                  class="invalid-feedback"
                  v-if="showSignUpError"
                  v-show="errors.has('register.confirmpassword')"
                  id="reset-confirm-psswrd-error"
																		data-test="resetPasswordConfirmPasswordInputError"
                >
                  The password confirmation does not match.
                </div>
              </div>
              <button
                class="btn col-12 btn-lg blue-btn continue-btn mt-2 mb-2"
                v-loading="loading"
                id="reset-passwrd-btn"
																data-test="resetPasswordBtn"
              >
                Reset Password
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { authenticationApi } from '@/services/ApiServices/authenticationApi'

export default {
	data () {
		return {
			email: '',
			password: '',
			confirmPassword: '',
			otp: '',
			loading: '',
			loadLogin: '',
			showSignUpError: false
		}
	},
	mounted () {
		// this.email = '';
		this.password = ''
		if (this.$route.name === 'ResetPassword') {
			// this.step = 2;
			this.otp = this.$route.params.token
		}
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.showSignUpError = false
					this.resetPassword()
				} else {
					this.showSignUpError = true
				}
			})
		},
		resetPassword () {
			this.loading = authenticationApi.resetPassword({
				token: this.otp,
				password: this.password,
				confirm_password: this.confirmPassword
			}).then((res) => {
				if (res.status === 200) {
					this.$forceUpdate()
					// this.$toasted.success(' Password Reset Successfully Please Login Again.');
					this.email = res.body.message
					this.loginAfterReset(this.email, this.password)
					// this.$router.push('/');
					setTimeout(() => 500)
				} else {
					this.$toasted.show(' Password reset request failed Please try again later. ',
						{ icon: 'exclamation-circle' })
				}
			}).catch((e) => {
				// this.$toasted.error('The token has expired or invalid try again later ',
				//   { icon: 'exclamation-circle' });
			})
		},
		loginAfterReset (email, password) {
			this.loadLogin = authenticationApi.login({
				username: email,
				password
			}).then((res) => {
				if (res.status === 200) {
					this.$router.push('/')
				} else {

				}
			})
		}
	}
}
</script>
